import * as React from 'react';
import * as classNames from "classnames";

export interface IContainerProps {
    addMargin: boolean;
    classNames?: string;
}

class ContentContainer extends React.Component<IContainerProps, any> {
    constructor(props, context) {
        super(props, context);
    }


    render() {
        return (
            this.props.children
        );
    }
}

export default ContentContainer;
